import { render, staticRenderFns } from "./SurveysAndCertsTab.vue?vue&type=template&id=293b5975&"
import script from "./SurveysAndCertsTab.vue?vue&type=script&lang=js&"
export * from "./SurveysAndCertsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports